import React from 'react'




import DeepCleaningHero from './DeepCleaningHero'
import DeepCleaningContent from './DeepCleaningContent'
import DeepCleaningServices from './DeepCleaningServices'
import DeepCleaningSTrustSection from './DeepCleaningSTrustsection'
import DeepCleaningSTransform from './DeepCleaningSTransform'
import Footer from '../../Footer/Footer'

function DeepCleaningCorporate() {
    return (
        <div>
            <DeepCleaningHero/>
            <DeepCleaningContent/>
            <DeepCleaningServices/>
            <DeepCleaningSTrustSection/>
            <DeepCleaningSTransform/>
            <Footer/>
            
        </div>
    )
}

export default DeepCleaningCorporate
